import {
  deliveryForecastComplete,
  statusRequiresDeliveryForecast,
} from './postSaleStatusDeadline';

const DATE_FORMAT = /^\d{2}\/\d{2}\/\d{4}$/;
const TIME_FORMAT = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

const blank = value => !String(value ?? '').trim();

export function transitionFormErrors(status, form) {
  const errors = {};
  if (statusRequiresDeliveryForecast(status) && blank(form.status_due_at)) {
    errors.status_due_at = 'REQUIRED';
  } else if (
    statusRequiresDeliveryForecast(status) &&
    !deliveryForecastComplete(form.status_due_at)
  ) {
    errors.status_due_at = 'INVALID_DATE';
  }

  if (status !== 'engenharia') return errors;

  if (blank(form.banco)) errors.banco = 'REQUIRED';
  if (blank(form.data_engenharia)) errors.data_engenharia = 'REQUIRED';
  else if (!DATE_FORMAT.test(form.data_engenharia)) {
    errors.data_engenharia = 'INVALID_DATE';
  }
  if (blank(form.hora_engenharia)) errors.hora_engenharia = 'REQUIRED';
  else if (!TIME_FORMAT.test(form.hora_engenharia)) {
    errors.hora_engenharia = 'INVALID_TIME';
  }

  return errors;
}
